import { render, staticRenderFns } from "./fileName.vue?vue&type=template&id=5d9f8a08&scoped=true&lang=pug"
import script from "./fileName.vue?vue&type=script&lang=js"
export * from "./fileName.vue?vue&type=script&lang=js"
import style0 from "./fileName.vue?vue&type=style&index=0&id=5d9f8a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f8a08",
  null
  
)

export default component.exports